import { useState } from "react";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ Authorization:"Bearer "+localStorage.getItem("nexo_token") });

export default function ExportPDF({ T, intervention, onClose }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [email, setEmail] = useState(intervention.client_email||"");
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const fetchHTML = async () => {
    const token = localStorage.getItem("nexo_token");
    const res = await fetch(`${BASE}/pdf/pv/${intervention.id}`, {
      headers:{ Authorization:`Bearer ${token}` }
    });
    if (!res.ok) throw new Error(`Erreur ${res.status}`);
    return await res.text();
  };

  const openAndPrint = async () => {
    setLoading(true);
    setError("");
    try {
      // Essayer d'abord le vrai PDF via puppeteer
      const token = localStorage.getItem("nexo_token");
      const modele = intervention.modele_pv || "";
      const pdfRes = await fetch(
        `${BASE}/pdf/generate/${intervention.id}?modele=${modele}`,
        {headers:{Authorization:`Bearer ${token}`}}
      );
      if (pdfRes.ok) {
        const blob = await pdfRes.blob();
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        // Fallback HTML
        const html = await fetchHTML();
        const win = window.open("about:blank","_blank");
        if (!win) { setError("Popup bloqué — autorisez les popups"); setLoading(false); return; }
        win.document.open(); win.document.write(html); win.document.close();
        win.onload = () => { setTimeout(()=>win.print(), 600); };
      }
    } catch(e) { setError(e.message); }
    setLoading(false);
  };

  const download = async () => {
    setLoading(true);
    setError("");
    try {
      const token = localStorage.getItem("nexo_token");
      const modele = intervention.modele_pv || "";
      const pdfRes = await fetch(
        `${BASE}/pdf/generate/${intervention.id}?modele=${modele}`,
        {headers:{Authorization:`Bearer ${token}`}}
      );
      const blob = pdfRes.ok ? await pdfRes.blob() : new Blob([await fetchHTML()], {type:"text/html"});
      const ext = pdfRes.ok ? "pdf" : "html";
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `PV_${intervention.reference||intervention.id.slice(-8)}_${new Date().toISOString().slice(0,10)}.${ext}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch(e) { setError(e.message); }
    setLoading(false);
  };

  const sendEmail = async () => {
    if (!email) return;
    setSending(true);
    try {
      const token = localStorage.getItem("nexo_token");
      const res = await fetch(`${BASE}/pdf/send-pv/${intervention.id}`, {
        method: "POST",
        headers: {"Content-Type":"application/json", Authorization:`Bearer ${token}`},
        body: JSON.stringify({email, modele: intervention.modele_pv||""})
      }).then(r=>r.json());
      if (res.ok) { setSent(true); }
      else { setError(res.error||"Erreur envoi"); }
    } catch(e) { setError(e.message); }
    setSending(false);
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,animation:"nx-modal-open 0.3s cubic-bezier(0.16,1,0.3,1) both",width:500,padding:28}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
          <div>
            <div style={{fontSize:18,fontWeight:800,color:T.text}}>📄 Exporter le PV</div>
            <div style={{fontSize:12,color:T.muted,marginTop:3}}>{intervention.titre}</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
        </div>

        {error&&<div style={{background:T.dangerDim,border:`1px solid ${T.danger}40`,borderRadius:9,padding:"10px 14px",fontSize:13,color:T.danger,marginBottom:14}}>⚠ {error}</div>}

        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <button onClick={openAndPrint} disabled={loading}
            style={{display:"flex",alignItems:"center",gap:14,padding:"16px 18px",borderRadius:13,border:`1.5px solid ${T.accent}`,background:T.accentDim,cursor:"pointer"}}>
            <div style={{width:44,height:44,borderRadius:11,background:T.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>🖨️</div>
            <div style={{flex:1,textAlign:"left"}}>
              <div style={{fontSize:14,fontWeight:700,color:T.accent}}>Aperçu & Imprimer</div>
              <div style={{fontSize:12,color:T.muted,marginTop:2}}>Ouvre le PV + dialogue d'impression</div>
            </div>
            {loading?<span style={{color:T.accent}}>⏳</span>:<span style={{color:T.accent,fontSize:18}}>→</span>}
          </button>

          <button onClick={download} disabled={loading}
            style={{display:"flex",alignItems:"center",gap:14,padding:"16px 18px",borderRadius:13,border:`1.5px solid ${T.success}`,background:`${T.success}15`,cursor:"pointer"}}>
            <div style={{width:44,height:44,borderRadius:11,background:T.success,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>⬇️</div>
            <div style={{flex:1,textAlign:"left"}}>
              <div style={{fontSize:14,fontWeight:700,color:T.success}}>Télécharger le PV</div>
              <div style={{fontSize:12,color:T.muted,marginTop:2}}>Fichier HTML — ouvrir dans Chrome → Imprimer → Enregistrer en PDF</div>
            </div>
            {loading?<span style={{color:T.success}}>⏳</span>:<span style={{color:T.success,fontSize:18}}>→</span>}
          </button>

          <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:13,padding:16}}>
            <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:10}}>📧 Envoyer par email</div>
            <div style={{display:"flex",gap:8}}>
              <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email du client..." type="email"
                style={{flex:1,background:T.card,border:`1px solid ${T.border}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:14,outline:"none"}}/>
              <button onClick={sendEmail} disabled={!email||sending||sent}
                style={{padding:"9px 16px",borderRadius:9,background:sent?T.success:email?T.accent:T.border,border:"none",color:"#fff",fontSize:13,fontWeight:700,cursor:email&&!sent?"pointer":"not-allowed",flexShrink:0}}>
                {sending?"⏳":sent?"✅":  "Envoyer"}
              </button>
            </div>
            {sent&&<div style={{fontSize:11,color:T.success,marginTop:8,fontWeight:600}}>✅ PV envoyé à {email}</div>}
          </div>
        </div>

        <button onClick={onClose} style={{width:"100%",marginTop:14,padding:"11px",borderRadius:10,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>
          Fermer
        </button>
      </div>
    </div>
  );
}
